import RegGuidelines from "../../components/Registration/RegGuidelines";
import RegistrationHub from "../../components/Registration/RegistrationHub";
import RegistrationMain from "../../components/Registration/RegistrationMain";
import RegJourney from "../../components/Registration/RegJourney";
import RegMap from "../../components/Registration/RegMap";
import RegPartners from "../../components/Registration/RegPartners";
import Reviews from "../reviews/Reviews";

const Registration = () => {
  return (
    <div>
      <RegistrationMain />
      <RegistrationHub />
      <RegPartners />
      <RegGuidelines />
      <RegJourney />
      <Reviews />
      <RegMap />
    </div>
  );
};

export default Registration;
